/**
 *
 */
export const isLiveStreamScheduledInTheFuture = (started_at) => started_at
    ? new Date(started_at).setHours(0, 0, 0, 0) >=
        new Date().setHours(0, 0, 0, 0)
    : false;
